// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"1f3a2121","2740":"68fc1d37","5066":"57d5ace2","5769":"230cf8f4","7945":"aec78970"}[chunkId] + ".css";
};